import RequestBase from "./RequestBase.ts";

export default class GroupRequests extends RequestBase {
    constructor(){
        super("Groups/");
    }
}